"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMessageSystem = void 0;
class MessageSystemImp {
    constructor() {
        this.messages = new Map();
        this.setMessages = (messages) => {
            for (const keyword in messages) {
                if (messages.hasOwnProperty(keyword)) {
                    const message = messages[keyword];
                    this.messages.set(keyword, message);
                }
            }
        };
        this.getMessage = (keyword, fallbackMessage) => {
            let msg = this.messages.get(keyword);
            if (msg === undefined) {
                msg = fallbackMessage;
            }
            return msg;
        };
    }
}
function makeMessageSystem() {
    return new MessageSystemImp();
}
exports.makeMessageSystem = makeMessageSystem;
